import { render, staticRenderFns } from "./MilestoneStep3.vue?vue&type=template&id=383520b2&scoped=true"
import script from "./MilestoneStep3.vue?vue&type=script&lang=js"
export * from "./MilestoneStep3.vue?vue&type=script&lang=js"
import style0 from "./MilestoneStep3.vue?vue&type=style&index=0&id=383520b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383520b2",
  null
  
)

export default component.exports